import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgHistoryMenu = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H18V18H0V0ZM4 14H6V7H4V14ZM10 14H8V4H10V14ZM12 14H14V10H12V14Z"
      fill="#79747E"
    />
  </svg>
);

export default SvgHistoryMenu;
